import { Component, Inject, Optional } from '@angular/core';
import {
  FQAN_jedgrad_id,
  FQAN_razina,
  Razina
} from '@app/components/hierarhija/hierarhija.component';
import { IzvjestajDownloadService } from '@app/components/izvjestaji/services/izvjestaj-dowload-content.service';
import { AppConfig, appConfigService } from '@app/config';
import {
  DataSource,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ServerItemAction
} from '@ntap/core';
import { Observable, map, take } from 'rxjs';

@Component({
  selector: 'app-print-omot-spisa-action',
  template: `<button
    pButton
    ntapDebounceClick
    label="Preuzmi omot spisa"
    [disabled]="(enabled$ | async) === false"
    (onClick)="executeAction()"
  ></button>`
})
export class IspisOmotaSpisaActionComponent extends ServerItemAction {
  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    protected documentsDownloadService: IzvjestajDownloadService,
    @Inject(appConfigService) private config: AppConfig
  ) {
    super(notificationService, itemProvider, dataSource, listViewProvider);
    this.config = config;
  }

  enabled$: Observable<boolean>;
  private baseUrl = this.config.apiHost;

  override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider.item$.pipe(
      map((item: any) => {
        return item[FQAN_razina] > Razina.PREDMET || item['$permission'] < 2;
      })
    );
  }

  override executeAction(): void {
    this.itemProvider?.item$.pipe(take(1)).subscribe((item: any) => {
      if (item) {
        const payload = {
          format: 'pdf',
          reportParams: {
            jedinica_gradiva_id: item[FQAN_jedgrad_id]
          }
        };
        this.doDownload(payload).subscribe();
      }
    });
  }

  doDownload(body: any) {
    const url = `${this.baseUrl}print-omota-spisa`;
    return this.documentsDownloadService.previewReportByUrl(url, body);
  }
}
